export type configObject = {
    midgardUrlPanel: string,
    defaultCurrency: string,
}
declare global {
    interface Window { config: configObject | null; }
}
const config: configObject = window.config || {
    midgardUrlPanel: process.env.VUE_APP_MIDGARD_URL_PANEL,
    defaultCurrency: process.env.VUE_APP_DEFAULT_CURRENCY
}
export default config
